import { topicsData } from '@/mocks/gossipData';

export default function Topics() {
  const colorMap: Record<string, string> = {
    primary: 'bg-primary-100 text-primary-700 hover:bg-primary-200 border-primary-200',
    accent: 'bg-accent-100 text-accent-700 hover:bg-accent-200 border-accent-200',
    secondary: 'bg-secondary-100 text-secondary-700 hover:bg-secondary-200 border-secondary-200',
  };

  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            话题热榜
          </h2>
          <p className="text-foreground-500 text-base">全网热议话题实时追踪</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topicsData.map((item, i) => (
            <div
              key={i}
              className={`group flex flex-col items-center gap-2 px-5 py-4 md:px-6 md:py-5 rounded-2xl border transition-all duration-200 cursor-default ${colorMap[item.color] || colorMap.primary}`}
            >
              <span className="text-sm md:text-base font-heading whitespace-nowrap">{item.name}</span>
              <span className="text-xs opacity-70 whitespace-nowrap">{item.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}